import React from "react"
import MainModul from "../../components/common/MainModul"
import { getTextAndHeadingClasses } from "../../services/functions"
import { API } from "../../constants/constants"
import { CropImageType } from "../../types"

type PageRendererProps = {
    modules: any[]
    primaryColorCode: string
}
export default function PageRenderer(props: PageRendererProps) {
    const modulRegistry: { [key: string]: React.ComponentType<any> } = {
        modul: MainModul,
    }

    const getShade = (shade?: string): string => {
        if (shade?.includes("modulSettingColorLight")) return "bg-base-200"
        if (shade?.includes("modulSettingColorSuperLight")) return "bg-base-300"
        if (shade?.includes("modulSettingColorWhite")) return "bg-none"
        if (shade?.includes("modulSettingColorPrimary")) return "bg-base-100"
        if (shade?.includes("modulSettingColorOptional")) return "bg-info"
        return ""
    }

    return (
        <>
            {props?.modules.map((modul, index) => {
                const ModulComponent = modulRegistry[modul?.type]
                if (!ModulComponent) {
                    return (
                        <div key={index}>
                            Kein Modul für Typ: <strong>{modul?.type}</strong>
                        </div>
                    )
                }
                const isPaddingTopSet = modul?.modulSettingPaddingTop !== ""
                const isPaddingBottomSet = modul?.modulSettingPaddingTop !== ""
                const cropImages: CropImageType = modul.modulSettingCropImageBlock
                return (
                    <div
                        key={index}
                        className={`
                          ${getShade(modul?.modulSettingColor)}      
                          ${getTextAndHeadingClasses(modul, props.primaryColorCode)}
                          ${isPaddingTopSet ? "pt-0" : "pt-8 md:pt-16"}
                          ${isPaddingBottomSet ? "pb-0" : "pb-8 md:pb-16"}
                          lg:rounded-default relative
                        `}
                        // TODO zIndexWork
                        style={{
                            zIndex: props.modules.length + index,
                            marginTop: modul?.modulSettingMarginTop + "px",
                            marginBottom: modul?.modulSettingMarginBottom + "px",
                            paddingTop: modul?.modulSettingPaddingTop + "px",
                            paddingBottom: modul?.modulSettingPaddingBottom + "px",
                        }}>
                        <ModulComponent {...modul} />

                        {modul.modulSettingCropImageToggle &&
                            cropImages.map((crop, index) => (
                                <img
                                    key={index}
                                    src={API + crop.modulSettingCropImage?.url}
                                    alt={crop.modulSettingCropImage?.description || crop.modulSettingCropImage?.name}
                                    style={{
                                        width: crop.modulSettingCropImageWidth + "px",
                                        top: crop.modulSettingCropImagePositionY + "%",
                                        left: crop.modulSettingCropImagePositionX + "%",
                                    }}
                                    className={`absolute w-24 object-contain hidden lg:block`}
                                />
                            ))}
                    </div>
                )
            })}
        </>
    )
}
